export default __webpack_public_path__ + "static/media/otp-icon.7db9a14e.png";